var _jsxFileName = "/opt/atlassian/pipelines/agent/build/src/components/connection/Partner/PartnerConnection/index.tsx";
import React, { useEffect } from 'react';
import { PartnerType } from 'Enums';
import { Main, TitleActionBar } from 'Components/utility';
import { cutString } from 'Utilities/dataHelpers';
import mediator from 'Utilities/mediator';
import CommercialApi from './CommercialApi';
import InboundApi from './InboundApi';
import PartnerApi from './PartnerApi';
import PumpPartner from './PumpPartner';
import Redox from './Redox';
const isValidPartnerType = type => {
  return Object.values(PartnerType).includes(type);
};
const PartnerConnection = ({
  data: {
    partnerConnection
  }
}) => {
  useEffect(() => {
    if (!partnerConnection || !isValidPartnerType(partnerConnection.partner.type)) {
      mediator.publish('router:navigate', '/connections');
    }
  }, [partnerConnection]);
  if (!partnerConnection) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Main, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 36,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(TitleActionBar, {
    testID: "PartnerConnection",
    title: cutString(partnerConnection.partner.name, 20),
    onBack: () => mediator.publish('router:navigate', '/connections'),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 37,
      columnNumber: 7
    }
  }), {
    [PartnerType.InboundApi]: /*#__PURE__*/React.createElement(InboundApi, {
      partnerConnection: partnerConnection,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 44,
        columnNumber: 37
      }
    }),
    [PartnerType.Redox]: /*#__PURE__*/React.createElement(Redox, {
      partnerConnection: partnerConnection,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 45,
        columnNumber: 32
      }
    }),
    [PartnerType.PartnerApi]: /*#__PURE__*/React.createElement(PartnerApi, {
      partnerConnection: partnerConnection,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 46,
        columnNumber: 37
      }
    }),
    [PartnerType.CommercialAPI]: /*#__PURE__*/React.createElement(CommercialApi, {
      partnerConnection: partnerConnection,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 47,
        columnNumber: 40
      }
    }),
    [PartnerType.PumpPartner]: /*#__PURE__*/React.createElement(PumpPartner, {
      partnerConnection: partnerConnection,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 48,
        columnNumber: 38
      }
    })
  }[partnerConnection.partner.type] ?? (() => {
    mediator.publish('router:navigate', '/connections');
    return null;
  })());
};
export default PartnerConnection;